import React from 'react'
import { Route, useRouteMatch } from 'react-router-dom'
import { useApiListNodeCourseVersion } from '../../../../../../api-new/state/content'
import { Menu, MenuEdit } from '../../../../../../shared/menu/menu'
import { IconList } from '../../../../../../shared/icon/icon'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnDateTime, ColumnMenu, ColumnText, ColumnYesNo } from '../../../../../../shared/table-builder/table-columns'
import { CourseNodeVersionEdit } from './node-course-version-edit'

export const NodeCourseVersionList = ({ nodeID }) => {
  const { url } = useRouteMatch()

  const apiListNodeCourseVersion = useApiListNodeCourseVersion()

  const handleReady = () => apiListNodeCourseVersion.get(`${nodeID}/node`)
  const handleDestroyed = () => apiListNodeCourseVersion.init()

  return (
    <React.Fragment>
      {/* Each version's metadata snapshot; named as the ⋮ menu item is
          (common/menu/node-actions.js). */}
      <BreadcrumbView Icon={IconList} text="version metadata">
        <CardFullHeightScrollY title="version metadata">
          <TableAgClient apiList={apiListNodeCourseVersion} sortCol="createdAt" sortDesc onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnDateTime field="createdAt" />
            <ColumnDateTime field="updatedAt" />
            <ColumnText field="nodeName" />
            <ColumnYesNo field="isCurrent" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuEdit to={`${url}/edit/${row.id}`} show />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/edit/:nodeCourseVersionID`}>
        <CourseNodeVersionEdit />
      </Route>
    </React.Fragment>
  )
}
